import { combineReducers } from 'redux';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createApiActionCreators,
  createReducer,
  createActionType,
  REQUEST,
  SUCCESS,
  FAILURE,
} from '../../../common/utils/reduxHelpers';
import api from '../api';

/**
 * ACTION TYPES
 */
export const FETCH_DISPOSALS = 'disposals/FETCH_DISPOSALS';

/**
 * ACTIONS
 */
export const fetchDisposalsActions = createApiActionCreators(FETCH_DISPOSALS);

/**
 * REDUCERS
 */
const initialState = {
  items: [],
  isFetching: false,
};

const disposals = createReducer(initialState, {
  [FETCH_DISPOSALS]: {
    [SUCCESS]: (state, payload) => ({
      items: payload.data,
      isFetching: false,
    }),
    [FAILURE]: state => ({
      items: [],
      isFetching: false,
    }),
  }
});

export default combineReducers({
  disposals,
});

/**
 * SELECTORS
 */
export const selectDisposalsState = state => state.disposals;
export const selectDisposals = state => selectDisposalsState(state).disposals;

/**
 * SAGAS
 */

function* fetchDisposals({ payload }) {
  const resp = yield call(api.fetchDisposals, payload);

  if (resp.ok) {
    yield put(fetchDisposalsActions.success(resp.data));
  } else {
    yield put(fetchDisposalsActions.failure(resp.error));
  }
}

export function* disposalsSaga() {
  yield takeLatest(createActionType(FETCH_DISPOSALS, REQUEST), fetchDisposals);
}



// WEBPACK FOOTER //
// ./src/features/disposals/ducks/index.js